module.exports = __webpack_public_path__ + "img/thumb-up.ea23bbcf.svg";